import type { CSSProperties, ReactNode } from 'react';
import type { Team } from '../data/types';

export function Ring({ pct, color, size = 46, thickness = 6, label, fontSize = 12, track = '#F0EFEB' }: {
  pct: number; color: string; size?: number; thickness?: number; label?: ReactNode; fontSize?: number; track?: string;
}) {
  const p = Math.max(0, Math.min(100, pct));
  return (
    <div className="ring" style={{ width: size, height: size, background: `conic-gradient(${color} ${p * 3.6}deg, ${track} 0)` }}>
      <span style={{ inset: thickness, fontSize }}>{label ?? `${Math.round(p)}%`}</span>
    </div>
  );
}

export function Avatars({ team, color, size = 24 }: { team: Team; color: string; size?: number }) {
  return (
    <span style={{ display: 'inline-flex' }}>
      {team.members.map(m => (
        <span key={m.uid} className="av" title={m.name} style={{ background: color, width: size, height: size }}>{m.initials}</span>
      ))}
    </span>
  );
}

export function Chip({ children, bg, fg, style }: { children: ReactNode; bg: string; fg: string; style?: CSSProperties }) {
  return <span className="chip" style={{ background: bg, color: fg, ...style }}>{children}</span>;
}
